interface LinkMapping {
  keywords: string[];
  url: string;
  title: string;
}

class ContentLinker {
  private linkMappings: LinkMapping[] = [
    {
      keywords: ['aging in place', 'age in place', 'staying at home', 'living at home', 'thrive at home'],
      url: '/older-adults',
      title: 'SeniorThrive for Older Adults'
    },
    {
      keywords: ['family caregiver', 'family caregiving', 'caring for parents', 'helping parents', 'family members'],
      url: '/thrivefamily',
      title: 'SeniorThrive for Family Members'
    },
    {
      keywords: ['professional caregiver', 'care professional', 'home care', 'caregiver support', 'care coordination'],
      url: '/caregivers',
      title: 'SeniorThrive for Caregivers'
    },
    {
      keywords: ['fall prevention', 'home safety', 'safety scan', 'fall risk', 'home hazard', 'safety assessment'],
      url: '/older-adults',
      title: 'Smart Home Safety'
    },
    {
      keywords: ['ThriveScore', 'wellness score', 'health score'],
      url: '/older-adults',
      title: 'ThriveScore Wellness Metric'
    },
    {
      keywords: ['wellness assessment', 'health check', 'wellness questionnaire'],
      url: '/older-adults',
      title: 'Wellness Assessments'
    },
    {
      keywords: ['care circle', 'ThriveCircle', 'support network'],
      url: '/thrivefamily',
      title: 'Build Your Care Circle'
    },
    {
      keywords: ['caregiver burnout', 'caregiver stress', 'caregiver well-being'],
      url: '/thrivefamily',
      title: 'Caregiver Support Resources'
    },
    {
      keywords: ['pricing', 'cost', 'subscription', 'plan', 'free trial'],
      url: '/pricing',
      title: 'SeniorThrive Pricing Plans'
    },
    {
      keywords: ['contact us', 'get started', 'learn more', 'support'],
      url: '/contact',
      title: 'Contact SeniorThrive'
    }
  ];

  processContent(htmlContent: string): string {
    let processedContent = htmlContent;

    this.linkMappings.forEach(mapping => {
      mapping.keywords.forEach(keyword => {
        // Create case-insensitive regex that doesn't match already linked content
        const regex = new RegExp(
          `(?<!<a[^>]*>.*?)\\b(${this.escapeRegex(keyword)})\\b(?![^<]*</a>)`,
          'gi'
        );
        
        processedContent = processedContent.replace(regex, (match) => {
          return `<a href="${mapping.url}" class="text-primary hover:underline font-medium" title="${mapping.title}">${match}</a>`;
        });
      });
    });

    return processedContent;
  }

  private escapeRegex(string: string): string {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  // Extract keywords from content for related posts matching
  extractKeywords(content: string): string[] {
    const text = this.stripHtml(content).toLowerCase();
    const keywords: string[] = [];

    this.linkMappings.forEach(mapping => {
      mapping.keywords.forEach(keyword => {
        if (text.includes(keyword.toLowerCase())) {
          keywords.push(keyword);
        }
      });
    });

    return keywords;
  }

  private stripHtml(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }
}

export const contentLinker = new ContentLinker();